import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { useResourcesMoveStore } from './moveResourcesStore.js';
import { pick } from '@fabric-app/utils/object/manipulation';
import { ModalMoveResources } from './ModalMoveResources.js';
import { dispatchFabricEvent } from '../../../hooks/useFabricEvent.js';

let timeout;
const ModalMoveWithGlobalStoreProps = () => {
  const { close, resources: resourcesGlobalState } = useResourcesMoveStore((state) => pick(state, [
    "close",
    "resources"
  ]));
  const [resources, setResources] = useState(resourcesGlobalState);
  useEffect(() => {
    clearTimeout(timeout);
    if (resourcesGlobalState) {
      setResources(resourcesGlobalState);
    } else {
      timeout = setTimeout(() => {
        setResources(null);
      }, 500);
    }
  }, [
    resourcesGlobalState
  ]);
  const handleMoveSuccess = () => {
    if (!resources) {
      return;
    }
    dispatchFabricEvent("fabric-resources-moved", {
      resourceIds: resources.map((resource) => resource.id)
    });
    close();
  };
  return /* @__PURE__ */ jsx(ModalMoveResources, {
    open: !!resourcesGlobalState,
    onClose: close,
    resources: resources || void 0,
    onMoveSuccess: handleMoveSuccess
  });
};

export { ModalMoveWithGlobalStoreProps };
//# sourceMappingURL=ModalMoveWithGlobalStoreProps.js.map
